import { getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createConversionOpportunitySamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.CONVERSION_OPPORTUNITY,
        ...getUserAndEventTime(),
        data: {
            conversionReason: 'retry-task',
            conversionToken: 'eyJ0eXBlIjoicmV0cnktdGFzayIsInRyYW5zYWN0Q29uZmlnIjp7InRhc2tJZFRvQ29udmVydCI6IjYzMzM2MTRlNzBkNzcwZjFhODE2MTdkMyIsInRhc2tzIjpbeyJwcm9kdWN0IjoiZGVwb3NpdCJ9XX19'
        }
    };
};
//# sourceMappingURL=conversion-opportunity.js.map